/** Meta stores budget/bid amounts in cents; the UI shows dollars. */
export function formatMetaAdsMoney(cents: number): string {
	return `$${(cents / 100).toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;
}

export function centsToDollars(cents: number): number {
	return cents / 100;
}

export function dollarsToCents(dollars: number): number {
	if (!Number.isFinite(dollars)) return 0;
	return Math.round(dollars * 100);
}
